function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 63h30a6 6 0 006-6V28.243a3 3 0 00-.879-2.122L42.88 9.88A3 3 0 0040.757 9H24a6 6 0 00-6 6v42a6 6 0 006 6zM9 4.5V9m0 0v4.5M9 9h4.5M9 9H4.5",
  stroke: "#4D4D4D",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDocumentAddComplex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "/img/document-add-complex.svg";
export { SvgDocumentAddComplex as ReactComponent };